module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_rc_9fe054b69cb05f5049b85a29ed1b3763.png";